import { render } from "./ManageCateoryModal.vue?vue&type=template&id=7ce54085"
import script from "./ManageCateoryModal.vue?vue&type=script&lang=js"
export * from "./ManageCateoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__